export default "__VITE_ASSET__wb4PVfqN__"